module.exports = __webpack_public_path__ + "static/media/slide1-usermanager.85e3da50.png";